module.exports = __webpack_public_path__ + "static/img/main-01.88f49a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/game/main-01.jpg
// module id = 8+77
// module chunks = 1